import RecommendationsPage from './Recommendations';

export default RecommendationsPage;
